import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

/* eslint import/namespace: ['error', { allowComputed: true }] */
import * as listActions from '~actions'
import { Table } from '~stories'

const capitalize = ([firstLetter, ...restOfWord]) =>
  firstLetter.toUpperCase() + restOfWord.join('')

const ItemList = ({
  columns,
  defaultVisibleColumns,
  fetchItems,
  filterKey,
  filterOptions,
  filterValue,
  params,
  rowClassName,
  rowKey,
  rows,
  rowsCount,
  showSecondaryFilter,
  secondaryFilter
}) => {
  return (
    <>
      <Table
        columns={columns}
        defaultVisibleColumns={defaultVisibleColumns}
        fetchData={fetchItems}
        filterKey={filterKey}
        filterOptions={filterOptions}
        filterValue={filterValue}
        params={params}
        results={rows}
        rowClassName={rowClassName}
        rowKey={rowKey}
        secondaryFilter={secondaryFilter}
        showSecondaryFilter={showSecondaryFilter}
        totalCount={rowsCount}
      />
    </>
  )
}

const mapStateToProps = (state, ownProps) => {
  const resource = ownProps.resource
  console.log(state, resource, `state[${resource}]`)
  const { params, rows, rowsCount } = state[`${resource}`]
  return {
    params,
    rows,
    rowsCount
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchItems: (props) => {
      let updatedProps = { ...props }
      if (ownProps.defaultFilter) {
        updatedProps = {
          ...props,
          ...ownProps.defaultFilter
        }
      }
      console.log(listActions, `fetch${capitalize(ownProps.resource)}List`)
      return dispatch(listActions[`fetch${capitalize(ownProps.resource)}List`](updatedProps))
    }
  }
}

ItemList.propTypes = {
  columns: PropTypes.array.isRequired,
  defaultVisibleColumns: PropTypes.arrayOf(PropTypes.string),
  fetchItems: PropTypes.func.isRequired,
  filterKey: PropTypes.string,
  filterOptions: PropTypes.array,
  filterValue: PropTypes.string,
  params: PropTypes.object,
  rowClassName: PropTypes.func,
  rowKey: PropTypes.string,
  rows: PropTypes.array,
  rowsCount: PropTypes.number,
  secondaryFilter: PropTypes.object,
  showSecondaryFilter: PropTypes.bool
}

ItemList.defaultProps = {
  filterValue: '',
  rows: [],
  secondaryFilter: null,
  showSecondaryFilter: false
}

export default React.memo(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ItemList)
)
